import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PrivilegeService } from "./../staff/Shared/privilege.service";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private privilegeService: PrivilegeService) { }

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {

    //     // check if route is restricted by role
    //     const documentId: any  = route.data;
    //     let retVal : boolean = false;

    //     this.privilegeService.GetPageSecuritybyRoleId(documentId.roles)
    //     .toPromise()
    //     .then(data => {

    //         console.log(data);
    //         if(data !== null){
    //             console.log(1);
    //              // role is authorised so redirect the page
    //             //  retVal = true;
    //             return true;
    //         }
    //         else{
    //             console.log(2);
    //             // role not authorised so redirect to unauthorised page
    //             this.router.navigate(['/']);
    //             // retVal = false;
    //             return false;
    //         }
    //     })
    //     .catch(err => { console.log(err) });

    //     // console.log("last");
    //     // console.log(retVal);
    //     // return retVal;


    //     // not logged in so redirect to login page with the return url
    //     // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //     // return false;
    // }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {

        // check if route is restricted by role Id
        // const documentId: any = route.data;

        // console.log(route.data.documentId[0]);
        const documentId: any = route.data.documentId[0];
        return this.PageSecuritybyRoleId(documentId);
    }

    PageSecuritybyRoleId(documentId: any): any {

        return new Promise<boolean>((resolve, reject) => {

            // this.privilegeService.GetPageSecuritybyRoleId(documentId.roles)
            
            this.privilegeService.GetPageSecuritybyRoleId(documentId)
                .toPromise()
                .then(data => {

                    if (data !== null) {
                        // role is authorised so redirect the page
                        if(data.IsView){
                            return true;
                        }
                        else{
                            this.router.navigate(['/unauthorised']);
                            return false;
                        }
                    }
                    else {
                        // role not authorised so redirect to unauthorised page
                        this.router.navigate(['/unauthorised']);
                        return false;
                    }
                })
                .catch(err => {
                    console.log(err)
                    return false;
                });

            resolve(true);
        });

    }
}
